import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/proposals/')({
  beforeLoad: () => {
    throw redirect({ to: '/history' })
  },
  component: ProposalsPage,
})

function ProposalsPage() {
  // This component won't render due to redirect
  return null;
}
